module.exports = __webpack_public_path__ + "img/maria_eva.219541a0.jpg";